import React from "react";

/**************************
 * 
 * Load bar component
 * 
 *************************/
const Loader = () => {
    return (
        <div className="load-bar">
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
        </div>
    );
};

export default Loader;
